import HealthBar from "@thilke/ui/components/health-bar";
import { cn } from "@thilke/ui/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const enemyHealthDisplayVariants = cva("relative w-full space-y-2", {
  variants: {
    size: {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

interface EnemyHealthDisplayProps
  extends React.ComponentProps<"div">,
    VariantProps<typeof enemyHealthDisplayVariants> {
  currentHealth: number;
  enemyName: string;
  level?: number;
  maxHealth: number;
  showHealthText?: boolean;
  showLevel?: boolean;
}

function EnemyHealthDisplay({
  className,
  currentHealth,
  enemyName,
  level,
  maxHealth,
  showHealthText = true,
  showLevel = true,
  size,
  ...props
}: EnemyHealthDisplayProps) {
  const healthPercentage =
    maxHealth > 0
      ? Math.max(0, Math.min(100, (currentHealth / maxHealth) * 100))
      : 0;

  return (
    <div
      className={cn(enemyHealthDisplayVariants({ size }), className)}
      {...props}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <span className="truncate font-semibold">{enemyName}</span>
          {showLevel && level ? (
            <span className="text-muted-foreground">Lv.{level}</span>
          ) : null}
        </div>
        {showHealthText ? (
          <span className="text-xs text-muted-foreground">
            {currentHealth}/{maxHealth}
          </span>
        ) : null}
      </div>
      <HealthBar value={healthPercentage} variant="segmented" />
    </div>
  );
}

export default EnemyHealthDisplay;
export type { EnemyHealthDisplayProps };
export { EnemyHealthDisplay, enemyHealthDisplayVariants };
